(() => {
  const theme = window.theme || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const formatMoney = (cents) => {
    const format = theme.moneyFormat || '₹{{amount}}';
    const value = Number(cents) / 100;
    const group = (num, decimals, thousands, decimal) => {
      const [whole, frac] = num.toFixed(decimals).split('.');
      const withSep = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? `${withSep}${decimal}${frac}` : withSep;
    };
    const formatted = format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      let out;
      switch (key) {
        case 'amount_no_decimals': out = group(value, 0, ',', '.'); break;
        case 'amount_with_comma_separator': out = group(value, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = group(value, 0, '.', ','); break;
        case 'amount_with_space_separator': out = group(value, 2, ' ', ','); break;
        case 'amount_with_apostrophe_separator': out = group(value, 2, "'", '.'); break;
        default: out = group(value, 2, ',', '.');
      }
      return out.replace(/[.,]00$/, '');
    });
    return formatted.replace(/<[^>]*>/g, '');
  };

  let toastTimer;
  const toast = (message) => {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = '';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2600);
  };

  /* Dialogs */
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-dialog]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.openDialog);
      if (dialog && !dialog.open) {
        dialog.showModal();
        opener.setAttribute('aria-expanded', 'true');
        dialog.addEventListener('close', () => opener.setAttribute('aria-expanded', 'false'), { once: true });
      }
      return;
    }
    const closer = event.target.closest('[data-close-dialog]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }
    if (event.target.tagName === 'DIALOG' && event.target.open) {
      const rect = event.target.getBoundingClientRect();
      const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) event.target.close();
    }
  });

  /* Header scroll state */
  const header = $('[data-header]');
  if (header) {
    let ticking = false;
    const update = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Account dropdown */
  document.addEventListener('click', (event) => {
    $$('[data-account-menu][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    $$('[data-account-menu][open]').forEach((menu) => {
      menu.removeAttribute('open');
      $('summary', menu).focus();
    });
  });

  /* Footer accordions collapsed on mobile */
  if (window.matchMedia('(max-width: 749px)').matches) {
    $$('[data-footer-details]').forEach((d) => d.removeAttribute('open'));
  }

  /* Cart */
  const drawer = () => document.getElementById('CartDrawer');
  const cartPage = () => $('[data-cart-page]');
  const isCartPage = () => !!cartPage();

  const sectionIds = () => {
    const ids = ['cart-drawer'];
    const page = cartPage();
    if (page) ids.push(page.dataset.section);
    return ids;
  };

  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', Number(count) === 0);
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
    $$('[data-cart-toggle]').forEach((el) => {
      const label = el.getAttribute('aria-label') || '';
      el.setAttribute('aria-label', label.replace(/\d+/, count));
    });
  };

  const renderSections = (sections) => {
    if (!sections) return;
    const parser = new DOMParser();
    if (sections['cart-drawer']) {
      const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = $('[data-cart-drawer-inner]', doc);
      const freshDialog = $('[data-cart-drawer]', doc);
      const current = $('[data-cart-drawer-inner]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      if (freshDialog) {
        drawer().dataset.count = freshDialog.dataset.count;
        updateCount(freshDialog.dataset.count);
      }
    }
    const page = cartPage();
    if (page && sections[page.dataset.section]) {
      const doc = parser.parseFromString(sections[page.dataset.section], 'text/html');
      const fresh = $('[data-cart-page-inner]', doc);
      const current = $('[data-cart-page-inner]', page);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
  };

  const openDrawer = () => {
    const d = drawer();
    if (d && !d.open) d.showModal();
  };

  const postJSON = async (url, body) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok) throw data;
    return data;
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-cart-toggle]');
    if (toggle && theme.cartType === 'drawer' && !isCartPage() && drawer()) {
      event.preventDefault();
      openDrawer();
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-product-form]');
    if (!form) return;
    if (theme.cartType === 'page' && !form.closest('.card')) return;
    event.preventDefault();

    const submitter = event.submitter || $('[type="submit"]', form);
    const formId = form.getAttribute('id');
    const buttons = formId ? $$(`[type="submit"][form="${formId}"], #${CSS.escape(formId)} [type="submit"]`) : [submitter];
    const errorEl = $('[data-form-error]', form);
    if (errorEl) errorEl.hidden = true;
    buttons.forEach((b) => b && b.classList.add('is-loading'));
    if (submitter) submitter.setAttribute('aria-busy', 'true');

    const formData = new FormData(form);
    formData.append('sections', sectionIds().join(','));
    formData.append('sections_url', window.location.pathname);

    try {
      const res = await fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await res.json();
      if (!res.ok || data.status) throw data;

      if (theme.cartType === 'page') {
        window.location.href = theme.routes.cart;
        return;
      }
      renderSections(data.sections);
      if (submitter && submitter.classList.contains('card__add')) {
        submitter.classList.add('is-added');
        setTimeout(() => submitter.classList.remove('is-added'), 1400);
      }
      if (isCartPage()) {
        toast(theme.strings.added);
      } else {
        openDrawer();
      }
    } catch (error) {
      const message = error.description || error.message || theme.strings.error;
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      } else {
        toast(message);
      }
    } finally {
      buttons.forEach((b) => b && b.classList.remove('is-loading'));
      if (submitter) submitter.removeAttribute('aria-busy');
    }
  });

  const changeLine = async (line, quantity) => {
    const containers = [$('[data-cart-drawer-inner]'), $('[data-cart-page] .lines')].filter(Boolean);
    containers.forEach((c) => c.classList.add('is-loading'));
    try {
      const data = await postJSON(`${theme.routes.cartChange}.js`, {
        line: Number(line),
        quantity: Math.max(0, Number(quantity)),
        sections: sectionIds(),
        sections_url: window.location.pathname
      });
      renderSections(data.sections);
    } catch (error) {
      toast(error.description || error.message || theme.strings.error);
    } finally {
      $$('.is-loading').forEach((c) => c.classList.remove('is-loading'));
    }
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-line-change]');
    if (!btn) return;
    event.preventDefault();
    changeLine(btn.dataset.lineChange, btn.dataset.quantity);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-line-input]');
    if (input) changeLine(input.dataset.lineInput, input.value);
  });

  const currentCodes = (scope) => $$('[data-discount-remove]', scope).map((b) => b.dataset.discountRemove);

  const applyDiscounts = async (codes, scope, attempted) => {
    const errorEl = $('[data-discount-error]', scope);
    if (errorEl) errorEl.hidden = true;
    try {
      const data = await postJSON(`${theme.routes.cartUpdate}.js`, {
        discount: codes.join(','),
        sections: sectionIds(),
        sections_url: window.location.pathname
      });
      const match = attempted && (data.discount_codes || []).find((d) => d.code.toLowerCase() === attempted.toLowerCase());
      renderSections(data.sections);
      if (attempted && (!match || !match.applicable)) {
        const freshScope = scope.id ? document.getElementById(scope.id) : null;
        const err = $('[data-discount-error]', freshScope || document);
        if (err) err.hidden = false;
      }
    } catch (error) {
      toast(error.description || theme.strings.error);
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-discount-form]');
    if (!form) return;
    event.preventDefault();
    const scope = form.closest('[data-cart-drawer-inner], [data-cart-page-inner]') || document;
    const code = form.discount.value.trim();
    if (!code) return;
    const codes = currentCodes(scope).filter((c) => c.toLowerCase() !== code.toLowerCase());
    codes.push(code);
    applyDiscounts(codes, scope, code);
  });

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-discount-remove]');
    if (!btn) return;
    const scope = btn.closest('[data-cart-drawer-inner], [data-cart-page-inner]') || document;
    const codes = currentCodes(scope).filter((c) => c !== btn.dataset.discountRemove);
    applyDiscounts(codes, scope);
  });

  let noteTimer;
  document.addEventListener('input', (event) => {
    const note = event.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => postJSON(`${theme.routes.cartUpdate}.js`, { note: note.value }).catch(() => {}), 500);
  });

  /* Product page */
  $$('[data-product-section]').forEach((section) => {
    const jsonEl = $('[data-product-json]', section);
    const form = document.getElementById(section.dataset.formId);
    if (!jsonEl || !form) return;
    const variants = JSON.parse(jsonEl.textContent);
    const fieldsets = $$('fieldset[data-option-index]', section);
    const idInput = $('[data-variant-id]', form);
    const track = $('[data-gallery-track]', section);
    const addButtons = $$('[data-add-button]', section);

    const selectedOptions = () => fieldsets.map((fs) => $('input:checked', fs)?.value);

    const markAvailability = (selected) => {
      fieldsets.forEach((fs, index) => {
        $$('[data-option-value]', fs).forEach((input) => {
          const candidate = [...selected];
          candidate[index] = input.value;
          const available = variants.some((v) => v.available && v.options.every((opt, i) => opt === candidate[i]));
          input.classList.toggle('is-unavailable', !available);
        });
      });
    };

    const goToMedia = (mediaId) => {
      if (!track || !mediaId) return;
      const slide = $(`[data-media-id="${mediaId}"]`, track);
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };

    const update = () => {
      const selected = selectedOptions();
      fieldsets.forEach((fs, i) => {
        const label = $('[data-option-selected]', fs);
        if (label) label.textContent = selected[i] || '';
      });
      markAvailability(selected);
      const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));

      addButtons.forEach((btn) => {
        const label = $('[data-add-label]', btn);
        if (!variant) {
          btn.disabled = true;
          if (label) label.textContent = theme.strings.unavailable;
        } else {
          btn.disabled = !variant.available;
          if (label) label.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
        }
      });
      if (!variant) return;

      idInput.value = variant.id;
      const priceWrap = $('[data-price]', section);
      if (priceWrap) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceWrap.classList.toggle('price--sale', !!onSale);
        priceWrap.classList.toggle('price--sold-out', !variant.available);
        const current = $('[data-price-current]', priceWrap);
        const compare = $('[data-price-compare]', priceWrap);
        const badge = $('[data-price-badge]', priceWrap);
        if (current) current.textContent = formatMoney(variant.price);
        if (compare) {
          compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
          compare.parentElement.hidden = !onSale;
        }
        if (badge) {
          badge.hidden = !onSale;
          if (onSale) {
            const pct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
            badge.textContent = badge.textContent.replace(/\d+/, pct);
          }
        }
      }
      const sticky = $('[data-sticky-price]', section);
      if (sticky) sticky.textContent = formatMoney(variant.price);
      if (variant.featured_media) goToMedia(variant.featured_media.id);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    fieldsets.forEach((fs) => fs.addEventListener('change', update));
    if (fieldsets.length) markAvailability(selectedOptions());

    const qty = $('[data-qty]', section);
    if (qty) {
      const input = $('[data-qty-input]', qty);
      $('[data-qty-minus]', qty).addEventListener('click', () => { input.value = Math.max(1, Number(input.value) - 1); });
      $('[data-qty-plus]', qty).addEventListener('click', () => { input.value = Number(input.value) + 1; });
    }

    if (track) {
      const dots = $$('[data-gallery-dot]', section);
      const thumbs = $$('[data-gallery-thumb]', section);
      const setActive = (index) => {
        dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
        thumbs.forEach((t, i) => {
          t.classList.toggle('is-active', i === index);
          if (i === index) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
      };
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => setActive(Math.round(track.scrollLeft / track.clientWidth)));
      }, { passive: true });
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.galleryThumb);
        track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
        setActive(index);
      }));
    }

    const stickyBar = $('[data-sticky-atc]', section);
    const mainAdd = $('.product-form__add', section);
    if (stickyBar && mainAdd && 'IntersectionObserver' in window) {
      const stickyBtn = $('button', stickyBar);
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(mainAdd);
    }
  });

  /* Collection filters */
  const facetsPanel = $('[data-facets-panel]');
  const facetsForm = $('[data-facets-form]');
  const backdrop = $('.facets-backdrop');
  const desktop = window.matchMedia('(min-width: 990px)');

  const setFacets = (open) => {
    if (!facetsPanel) return;
    facetsPanel.classList.toggle('is-open', open);
    if (backdrop) backdrop.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
    $$('[data-facets-open]').forEach((b) => b.setAttribute('aria-expanded', open ? 'true' : 'false'));
    if (open) facetsPanel.querySelector('summary, input, button')?.focus();
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-facets-open]')) setFacets(true);
    if (event.target.closest('[data-facets-close]')) setFacets(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && facetsPanel?.classList.contains('is-open')) setFacets(false);
  });

  const submitFacets = () => {
    if (!facetsForm) return;
    const params = new URLSearchParams();
    new FormData(facetsForm).forEach((value, key) => {
      if (value !== '') params.append(key, value);
    });
    window.location.search = params.toString();
  };

  if (facetsForm) {
    facetsForm.addEventListener('submit', (event) => {
      event.preventDefault();
      submitFacets();
    });
    let facetTimer;
    facetsForm.addEventListener('change', () => {
      if (!desktop.matches) return;
      clearTimeout(facetTimer);
      facetTimer = setTimeout(submitFacets, 350);
    });
  }

  $$('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const hidden = facetsForm && $('[data-sort-hidden]', facetsForm);
      if (hidden) {
        hidden.value = select.value;
        submitFacets();
      } else {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.href = url.toString();
      }
    });
  });

  /* Wishlist */
  const WISHLIST_KEY = 'sushi:wishlist';
  const readWishlist = () => {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  };
  const syncWishlist = (root = document) => {
    const list = readWishlist();
    $$('[data-wishlist]', root).forEach((btn) => btn.setAttribute('aria-pressed', list.includes(btn.dataset.wishlist) ? 'true' : 'false'));
  };
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-wishlist]');
    if (!btn) return;
    event.preventDefault();
    const handle = btn.dataset.wishlist;
    let list = readWishlist();
    const saved = list.includes(handle);
    list = saved ? list.filter((h) => h !== handle) : [...list, handle];
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) { /* storage unavailable */ }
    syncWishlist();
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    btn.classList.add('is-pop');
    toast(saved ? theme.strings.wishlistRemoved : theme.strings.wishlistAdded);
  });
  syncWishlist();

  /* Product recommendations */
  $$('[data-recommendations]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recommendations]', doc);
      const count = (root) => root.querySelectorAll('.product-row__item').length;
      if (fresh && count(fresh) > 0 && count(fresh) >= count(el)) {
        el.innerHTML = fresh.innerHTML;
        syncWishlist(el);
      }
    } catch (e) { /* recommendations are optional */ }
  });

  /* Login / recover password panels */
  const panels = $$('[data-auth-panel]');
  if (panels.length) {
    const show = (name) => panels.forEach((p) => { p.hidden = p.dataset.authPanel !== name; });
    if (window.location.hash === '#recover') show('recover');
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-auth-switch]');
      if (!link) return;
      event.preventDefault();
      show(link.dataset.authSwitch);
      history.replaceState(null, '', `#${link.dataset.authSwitch}`);
    });
  }
})();
